import { UserRole } from '../models';

export enum UserField {
  Code = 'code',
  Name = 'name',
  Description = 'description',
  Role = 'role',
  EarningRate = 'earningRate',
  Password = 'password',
  AttachedPartners = 'attachedPartners',
  AttachedRtb = 'attachedRtb',
  CreatedAt = 'createdAt',
}

export const userLabels = {
  [UserField.Code]: 'User code',
  [UserField.Name]: 'User name',
  [UserField.Description]: 'Description',
  [UserField.Role]: 'User role',
  [UserField.EarningRate]: 'Earning rate',
  [UserField.Password]: 'Password',
  [UserField.CreatedAt]: 'Registration date',
  [UserField.AttachedPartners]: 'Attach partner',
  [UserField.AttachedRtb]: 'Attach RTB',
};

export const userRoleLabels = {
  [UserRole.Admin]: 'Admin',
  [UserRole.Supervisor]: 'Supervisor',
  [UserRole.Manager]: 'Manager',
  [UserRole.Moderator]: 'Moderator',
  [UserRole.Advertiser]: 'Advertiser',
  [UserRole.Analyst]: 'Analyst',
  [UserRole.DemoVisitor]: 'Demo',
  [UserRole.Publisher]: 'Publisher',
};
